const customShape = {
    borderRadius: 10,
};

export default customShape;
